import { TextareaAutosize } from "@mui/material";
import { TagCellContext } from "./types";
import { stripNull } from "helpers/coll";
import { cn } from "components/lib/utils";
import { Maybe } from "generated/graphql";

export function TagDescription({
  row,
  isEditing,
  setIsEditing,
  updateTag,
  onSave,
}: TagCellContext<Maybe<string> | undefined>) {
  const editing = isEditing(row.id);
  const tag = row.original;

  return (
    <span
      className="w-full justify-between inline-flex items-center gap-1"
      onClick={() => !editing && setIsEditing(row.id)}>
      {editing ? (
        <TextareaAutosize
          minRows={1}
          maxRows={5}
          className="w-full bg-white p-0 focus:ring-peri-300"
          value={tag.description ?? ""}
          onChange={(e) => updateTag({ ...tag, description: e.target.value })}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              onSave(tag);
            }
          }}
        />
      ) : (
        <span
          className={cn(
            "py-1 whitespace-pre-wrap",
            stripNull(tag.description) === undefined ? "text-gray-100 italic" : ""
          )}
          onClick={() => setIsEditing(row.id)}>
          {tag.description ?? "Enter description"}
        </span>
      )}
    </span>
  );
}
